/**
 * 定义全局方法
 */
let downloadGet = function(url) {
    return download.call(this, {method:'get', url:url});
}

let downloadPost = function(url, data){
    return download.call(this, {method:'post', url:url, data:data});
}

let download = async function({method = 'get', url = '', data = {}, responseType = 'arraybuffer'} = {}) {
    let res = await this.$axios({method:method, url:url, data:data, responseType:responseType});

    if (!res.headers || res.headers['content-type'] !== 'application/octet-stream'){
        let enc = new TextDecoder('utf-8');
        let err = JSON.parse(enc.decode(new Uint8Array(res))); //转化成json对象
        return Promise.resolve(err);
        // this.$message.error(`下载失败:${err.errMsg}`);
        // return;
    }

    let fileName = decodeURIComponent(res.headers["content-disposition"].split(";")[1].split("filename=")[1]);
    if ('msSaveOrOpenBlob' in navigator) {//IE导出
        window.navigator.msSaveOrOpenBlob(res.data, fileName);
    } else {
        // 这种方案会导致白屏
        // var reader = new FileReader();
        // reader.readAsDataURL(res.data);    // 转换为base64，可以直接放入a表情href
        // reader.onload = function (e) {
        //     // 转换完成，创建一个a标签用于下载
        //     var a = document.createElement('a');
        //     a.download = fileName;
        //     a.href = e.target.result;
        //     document.body.append(a);
        //     a.click();
        //     document.body.remove(a);
        // }

        let href = window.URL.createObjectURL(new Blob([res.data]));
        let link = document.createElement('a');
        link.style.display = 'none';
        link.href = href;
        link.setAttribute('download', decodeURI(fileName));
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
    return Promise.resolve({code:200});
}

const install = function(Vue, options) {
    Vue.prototype.getCurrentUser = function (){
        //重新检查当前登录人信息
        if (JSON.stringify(this.$store.state.userInfo) === '{}') {
            this.$axios.get("/user/getCurrentUser")
            .then(res => {
                if (res.code === 200) {
                    this.$store.commit('updateUserInfo', res.data);
                } else {
                    this.$alert(res.errMsg, "错误提示")
                    .then(data => {
                        this.$router.replace("/login");
                    });
                }
            }).catch(err => {});
        }
    };

    //……添加其他的全局方法
    Vue.prototype.download = download;
    Vue.prototype.downloadGet = downloadGet;
    Vue.prototype.downloadPost = downloadPost;
}
export default install;